import { render } from "./App.vue?vue&type=template&id=203b9da6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=203b9da6&lang=scss"

import exportComponent from "D:\\develope\\back\\admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__